import { RefObject, useEffect, useState } from 'react';

export interface ResizeObserverDimensions {
  height: number;
  width: number;
}

export const useResizeObserver = (ref: RefObject<HTMLElement | null>,
  cb: (dimensions: ResizeObserverDimensions) => void) => {
  useEffect(() => {
    const refCurrent = ref.current;
    let resizeObserver: ResizeObserver;

    if (ref?.current) {
      resizeObserver = new ResizeObserver(entries => {
        const [entry] = entries;
        const { height = 0, width = 0 } = entry?.contentRect ?? {};

        cb({ height, width });
      });

      resizeObserver.observe(ref.current);
    }

    return () => {
      if (resizeObserver && refCurrent) {
        resizeObserver.unobserve(refCurrent);
      }
    };
  },
  [cb, ref]);
};

export const useObserveRefDimensions = (ref: RefObject<HTMLElement>) => {
  const [dimensions, setDimensions] = useState<ResizeObserverDimensions>({
    height: 0,
    width: 0,
  });

  const currentRef = ref?.current;

  useResizeObserver(ref,
    setDimensions);

  useEffect(() => {
    if (currentRef) {
      setDimensions({
        height: currentRef.clientHeight,
        width: currentRef.clientWidth,
      });
    }
  },
  [currentRef]);

  return dimensions;
};
